// ParentPortalPageTemplate.js
import React from "react";

const ParentPortalPageTemplate = ({ title, children }) => (
  <div className="parent-portal-page-outer w-full py-0 lg:py-2">
    <div className="w-full max-w-5xl mx-auto text-[#2e3c42] dark:text-gray-200">
      {title && <span className="sr-only">{title}</span>}
      {children}
    </div>
  </div>
);

export default ParentPortalPageTemplate;
